// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__bzlNF","tagButton":"styles_tagButton__cVpE5","icon":"styles_icon__Bvswt","label":"styles_label__tu7mi"};